/** venture/VicsLogin.tsx — VICS 로그인 정보 한 줄 (ID 복사 · PW 가림/보기·복사 · 로그인 링크) — 13단계·1329·정기·결산 보고 공용 (2026-09-24) */
import React, { useState } from 'react';
import { getS3 } from './stepcommon';
import { copyText } from './VicsStage';
import { VICS_URL } from './vics13';
import type { Project } from './types';

export default function VicsLogin({ p, toast, compact }: { p: Project; toast: (m: string) => void; compact?: boolean }) {
  const vics = getS3(p).vics;
  const [show, setShow] = useState(false);
  const has = !!(vics.id && vics.pw);
  return (
    <div className={'vlogin1' + (compact ? ' compact' : '')}>
      <span className="vk">🔑 VICS</span>
      {has ? (<>
        <span className="vitem"><span className="vl">ID</span><code>{vics.id}</code><button type="button" className="rbtn" onClick={() => copyText(vics.id, toast, 'ID를 복사했습니다')}>복사</button></span>
        <span className="vitem"><span className="vl">PW</span><code>{show ? vics.pw : '•'.repeat(Math.min(10, Math.max(6, vics.pw.length)))}</code>
          <button type="button" className="rbtn" title={show ? '가리기' : '보기'} onClick={() => setShow(!show)}>{show ? '가림' : '👁'}</button>
          <button type="button" className="rbtn" onClick={() => copyText(vics.pw, toast, 'PW를 복사했습니다')}>복사</button></span>
      </>) : <span className="pill p-amber">3단계에서 VICS ID·PW 입력 필요</span>}
      <a className="upbtn link" href={VICS_URL} target="_blank" rel="noopener noreferrer" style={{ fontSize: 10.5, padding: '3px 8px' }}>🔗 VICS 로그인</a>
    </div>
  );
}
